import React, {useContext} from 'react';
import {FilterListOutlined} from "@material-ui/icons";
import useDialogState from "../hooks/useDialogState";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core";
import {textButton} from "../utils/styles";
import DialogFiltro from "./DialogFiltro";
import SituacaoContext from "../contexts/situacao";

const useStyles = makeStyles(theme => ({
    ...textButton(theme)
}));

const getDescricaoSituacao = situacao => {
    switch (situacao) {
        case 'T':
            return 'Todos';
        case 'N':
            return 'Em aberto';
        case 'V':
            return 'Vencidos';
        case 'A':
            return 'À vencer';
        case 'S':
            return 'Pagos';
    }
};

export default function ButtonFiltro(props) {
    const {
        onFilter,
        disabled = false
    } = props;
    const classes = useStyles();
    const {situacao} = useContext(SituacaoContext);
    const {
        dialogState,
        openDialog,
        closeDialog
    } = useDialogState({
        filtro: false
    });

    return (
        <>
            <Button
                className={classes.textButton}
                startIcon={<FilterListOutlined />}
                onClick={openDialog('filtro')}
                disabled={disabled}>
                Filtro ({getDescricaoSituacao(situacao)})
            </Button>
            <DialogFiltro
                open={dialogState.filtro}
                onClose={closeDialog('filtro')}
                onFilter={onFilter} />
        </>
    );
}